import React from 'react';
import type { AppConfig } from '../../../shared/components/global-nav/app-config';
import type { AvailableAppItem } from '../../../shared/components/global-nav/use-available-apps';

type ManagerSelectionContextValue = {
  availableApps: AvailableAppItem[];
  selectedItem: AvailableAppItem | undefined;
  selectItem: (item: AvailableAppItem) => void;
  selectedAppConfig: AppConfig;
  /** Grants are settled and hold no app this deployment can open — an answer, not a load (FR-013). */
  hasNoApps: boolean;
};

export const ManagerSelectionContext = React.createContext<ManagerSelectionContextValue | null>(
  null,
);

export function useManagerSelection(): ManagerSelectionContextValue {
  const ctx = React.useContext(ManagerSelectionContext);
  if (!ctx) {
    throw new Error('useManagerSelection must be used within ManagerSelectionProvider');
  }
  return ctx;
}
